import { Box } from '@mui/material';
import styled from 'styled-components';
import { RadioGroup } from '@mui/material';
import { Rating } from '@mui/material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: white;
`;

export const ContentContainer = styled(Box)`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  padding-bottom: calc(140px + env(safe-area-inset-bottom));
`;

export const InfoBox = styled(Box)`
  background-color: #f0f7ff;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 24px;
`;

export const ButtonContainer = styled(Box)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  background-color: #fff;
  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 10;
`;

export const ModalButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 16px 24px;
  
  .MuiButton-root {
    width: 100%;
  }
`;

export const StyledRadioGroup = styled(RadioGroup)`
  .MuiFormControlLabel-root {
    margin: 8px 0;
  }
`;

interface ContactFieldProps {
  $visible: boolean;
}

export const ContactField = styled(Box) <ContactFieldProps>`
  margin-top: 16px;
  display: ${props => props.$visible ? 'block' : 'none'};
`;

export const SectionContainer = styled(Box)`
  margin-bottom: 24px;
`;

export const HeaderContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  
  .title-help-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
  }
`;

export const OptionContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StyledRating = styled(Rating)`
  margin: 8px 0;
  display: flex;
  align-items: center;
`;

export const StyledAccountCircleOutlinedIcon = styled(AccountCircleOutlinedIcon)`
  color: var(--primary-green);
`;

export const StyledChatBubbleOutlineOutlinedIcon = styled(ChatBubbleOutlineOutlinedIcon)`
  color: #ffd700;
`;

export const StyledAccessTimeOutlinedIcon = styled(AccessTimeOutlinedIcon)`
  color: #9932CC;
`;

export const StyledAttachMoneyOutlinedIcon = styled(AttachMoneyOutlinedIcon)`
  color: var(--warning-main);
  margin-right: -4px;
`;

export const StyledMenuBookOutlinedIcon = styled(MenuBookOutlinedIcon)`
  color: var(--primary-blue);
`;

export const RatingWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 8px 0;

  .rating-help-container {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 24px;
  }
`;

export const StyledHelpIcon = styled(HelpOutlineIcon)`
  color: var(--text-secondary);
  font-size: 18px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
  margin-left: 4px;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 1;
  }
`;